<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <rect width="15" height="11" x=".5" y="2.5" stroke="currentColor" rx=".5" ry=".5"></rect>
    <path fill="currentColor" d="M.5 5h15v2H.5z"></path>
  </g>
</svg>
